import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

/* get the Saved Videos */
export const getSavedFolders = createAsyncThunk(
    "getSavedFolders",
    async (id) => {
        const response = await axiosInstance.get(`/post/folders/${id}/`);
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

/* delete the folder */
export const deleteSavedFolders = createAsyncThunk(
    "deleteSavedFolders",
    async (id) => {
        const response = await axiosInstance.delete(`/post/folders/${id}/`);
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

/* delete the folder inside video delete */
export const deleteSavedVideo = createAsyncThunk(
    "deleteSavedVideo",
    async (data) => {
        const response = await axiosInstance.delete(`/post/folders/${data.folder_id}/delete_video/${data.post_id}/`);
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

/* Rename the folder */
export const renameSavedFolders = createAsyncThunk(
    "renameSavedFolders",
    async (data) => {
        let form_data = new FormData();
        form_data.append("name", data.name);
        try {
            const response = await axiosInstance.put(
                `/post/folders/${data.folderId}/`,
                form_data,
                {
                    headers: {
                        "content-type": "multipart/form-data",
                    },
                }
            );
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

/* create the folder */
export const createFolder = createAsyncThunk("createFolder", async (data) => {
    let form_data = new FormData();
    form_data.append("name", data.name);
    try {
        const response = await axiosInstance.post(
            `/post/folders/${data.userId}/`,
            form_data,
            {
                headers: {
                    "content-type": "multipart/form-data",
                },
            }
        );
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

/* add the video into save folder */
export const SavedTheVideoInsideFolder = createAsyncThunk("SavedTheVideoInsideFolder", async (data) => {
    const response = await axiosInstance.post(`/post/saved_posts/${data.videoId}/move-to-folder/${data.folderId}/`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

/* get individual folder data */
export const getIndividualFolderData = createAsyncThunk(
    "getIndividualFolderData",
    async (data) => {
        const response = await axiosInstance.get(`/post/folders/${data}/`);
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

// Save Video by Id
export const SavedVideosById = createAsyncThunk(
    "SavedVideosById",
    async (id) => {
        const response = await axiosInstance.post(`/post/toggle_save_post/${id}/`);
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    },
);

// Move video to another folder
export const moveVideoToFolder = createAsyncThunk(
    "moveVideoToFolder",
    async ({ sourceFolderId, targetFolderId, postId }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/post/move_post/${sourceFolderId}/${targetFolderId}/${postId}/`);
            return response.data;
        } catch (error) {
            console.error("Error moving video:", error);
            return rejectWithValue(error.response?.data || "Failed to move video");
        }
    }
);

// Bulk move posts to a target folder
export const bulkMoveSavedPostsToFolder = createAsyncThunk(
    "bulkMoveSavedPostsToFolder",
    async ({ folderId, postIds }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `/post/saved_posts/bulk-move-to-folder/${folderId}/`,
                { post_ids: postIds }
            );
            return response.data;
        } catch (error) {
            console.error("Error bulk moving videos:", error);
            return rejectWithValue(error.response?.data || "Failed to move videos");
        }
    }
);

// Bulk remove posts from a folder
export const bulkRemoveSavedPostsFromFolder = createAsyncThunk(
    "bulkRemoveSavedPostsFromFolder",
    async ({ folderId, postIds }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `/post/folders/${folderId}/bulk-remove/`,
                { post_ids: postIds }
            );
            return response.data;
        } catch (error) {
            console.error("Error bulk removing videos:", error);
            return rejectWithValue(error.response?.data || "Failed to remove videos");
        }
    }
);

// Bulk unsave posts from saved list
export const bulkUnsavePosts = createAsyncThunk(
    "bulkUnsavePosts",
    async (postIds, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `/post/saved_posts/bulk-unsave/`,
                { post_ids: postIds }
            );
            return { data: response.data, postIds };
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed to unsave posts");
        }
    }
);

// Saved Video List
export const savedVideoList = createAsyncThunk("savedVideoList", async ({ nextUrl, isLoadMore } = {}) => {

    // const url = nextUrl && isLoadMore ? nextUrl : `/post/saved_posts/`;
    try {
        let response;
        if (nextUrl) {
            const url = new URL(nextUrl);
            const pathAndQuery = url.pathname + url.search;
            const relativePath = pathAndQuery.replace('/api', '');
            response = await axiosInstance.get(relativePath);
        } else {
            response = await axiosInstance.get(`/post/saved_posts/`);
        }
        const result = response.data;
        return { ...result, isLoadMore };
    } catch (error) {
        return error;
    }
});


export const SavedVideosSlice = createSlice({
    name: "SavedVideosSlice",
    initialState: {
        SavedVideos: [],
        SavedFolderList: [],
        FolderData: [],
        loading: false,
        loadingMore: false,
        error: null,
        nextPage: null,
        totalCount: 0,
    },
    reducers: {
        resetLoadingMore: (state) => {
            state.loadingMore = false;
        },
    },
    extraReducers: (builder) => {
        // SavedVideosSlice action promises
        builder.addCase(createFolder.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createFolder.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(createFolder.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // getSavedFolders action promises
        builder.addCase(getSavedFolders.pending, (state) => {
            state.loading = true;
            state.SavedFolderList = []
        });
        builder.addCase(getSavedFolders.fulfilled, (state, action) => {
            state.SavedFolderList = action.payload;
            state.loading = false;
        });
        builder.addCase(getSavedFolders.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // SavedTheVideoInsideFolder action promises
        builder.addCase(SavedTheVideoInsideFolder.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(SavedTheVideoInsideFolder.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(SavedTheVideoInsideFolder.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // getIndividualFolderData action promises
        builder.addCase(getIndividualFolderData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getIndividualFolderData.fulfilled, (state, action) => {
            state.FolderData = action.payload;
            state.loading = false;
        });
        builder.addCase(getIndividualFolderData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Save Video by Id action promises
        builder.addCase(SavedVideosById.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(SavedVideosById.fulfilled, (state, action) => {
            // state.SavedVideos = action.payload;

            state.SavedVideos = action.payload?.result?.message.includes("unsaved") ? state.SavedVideos.filter((video => video.id !== action.payload.id)) : state.SavedVideos;
            state.loading = false;
        });
        builder.addCase(SavedVideosById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Move video to folder action promises
        builder.addCase(moveVideoToFolder.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(moveVideoToFolder.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(moveVideoToFolder.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Bulk move video to folder action promises
        builder.addCase(bulkMoveSavedPostsToFolder.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(bulkMoveSavedPostsToFolder.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(bulkMoveSavedPostsToFolder.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Bulk remove video from folder action promises
        builder.addCase(bulkRemoveSavedPostsFromFolder.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(bulkRemoveSavedPostsFromFolder.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(bulkRemoveSavedPostsFromFolder.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Saved Video List action promises
        builder.addCase(savedVideoList.pending, (state, action) => {
            const { isLoadMore } = action.meta.arg || {};
            if (isLoadMore) {
                state.loadingMore = true;
            } else {
                state.loading = true;
            }
        });
        builder.addCase(savedVideoList.fulfilled, (state, action) => {
            const { isLoadMore } = action.payload;

            if (isLoadMore) {
                // Append to existing data for load more
                if (action.payload.results && Array.isArray(action.payload.results.saved_posts)) {
                    state.SavedVideos = [
                        ...state.SavedVideos,
                        ...action.payload.results.saved_posts
                    ];
                }
                state.loadingMore = false;
            } else {
                // Replace data for initial load
                state.SavedVideos = action.payload?.results?.saved_posts || [];
                state.loading = false;
                state.totalCount = action.payload?.count ?? state.SavedVideos.length;
            }

            // Update pagination info
            state.nextPage = action.payload?.next || null;
        });
        builder.addCase(savedVideoList.rejected, (state, action) => {
            const { isLoadMore } = action.meta.arg || {};
            state.error = action.payload;
            if (isLoadMore) {
                state.loadingMore = false;
            } else {
                state.loading = false;
            }
        });

        // Bulk unsave posts
        builder.addCase(bulkUnsavePosts.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(bulkUnsavePosts.fulfilled, (state, action) => {
            state.loading = false;
            state.SavedVideos = state.SavedVideos.filter(
                (video) => !action.payload.postIds.includes(video.id)
            );
            state.totalCount = state.SavedVideos.length;
        });
        builder.addCase(bulkUnsavePosts.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //delete saved video from Save
        builder.addCase(deleteSavedVideo.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteSavedVideo.fulfilled, (state, action) => {
            state.loading = false;
            // state.SavedVideos = state.SavedVideos.filter((video) => video.id !== action.payload.id);
        });
        builder.addCase(deleteSavedVideo.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { resetLoadingMore } = SavedVideosSlice.actions;
export default SavedVideosSlice.reducer;